(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["milora-design-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('milora-cart-upgrade')) {
  customElements.define('milora-cart-upgrade', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.bound = true;
      this.button.addEventListener('click', () => this.upgrade());
    }
    async upgrade() {
      if (this.button.disabled) return;
      const button = this.button;
      const label = button.textContent;
      const error = this.querySelector('[role="alert"]');
      button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      const drawer = this.closest('cart-drawer');
      try {
        if (!drawer?.renderContents) throw new Error('Drawer unavailable');
        const sections = drawer.getSectionsToRender().map(section => section.id);
        let data;
        if (!this.added) {
          const currentResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
          if (!currentResponse.ok) throw new Error('Cart unavailable');
          const current = await currentResponse.json();
          const mainQuantity = current.items.filter(item => String(item.variant_id) === this.dataset.main).reduce((sum, item) => sum + item.quantity, 0);
          if (mainQuantity !== 1) throw new Error('Cart changed');
          const items = JSON.parse('[' + this.dataset.items + ']').map(item => ({id: item.id, quantity: Math.max(0, 1 - current.items.filter(line => line.variant_id === item.id).reduce((sum, line) => sum + line.quantity, 0))})).filter(item => item.quantity > 0);
          if (items.length) {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json', Accept: 'application/json'},
              body: JSON.stringify({items, sections, sections_url: window.location.pathname})
            });
            data = await response.json();
            if (!response.ok || data.status) throw new Error('Cart add failed');
          }
          this.added = true;
        }
        if (!data?.sections || !sections.every(id => data.sections[id])) {
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('sections', sections.join(','));
          const response = await fetch(url, {headers: {Accept: 'application/json'}, cache: 'no-store'});
          if (!response.ok) throw new Error('Cart refresh failed');
          data = {sections: await response.json()};
        }
        if (!sections.every(id => data.sections[id])) throw new Error('Cart refresh failed');
        drawer.renderContents(data);
        drawer.classList.remove('is-empty');
        drawer.open();
        requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
      } catch (_) {
        error.hidden = false;
        button.textContent = this.added ? this.dataset.refreshLabel : label;
      } finally {
        button.disabled = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
